import React, { Component } from 'react';
import { do_action } from '../../actions';
import {BASE_URL_ADMIN} from '../../data/config';

class ModalAddItemDesigner extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            selectItemId: "",
            quantity: 1,
            selectItem: {},
            dataCategory: {}
        }
    }

    componentWillReceiveProps(nextProps, nextState){
        let { vendor } = this.props
        if (nextProps.nb_add != this.props.nb_add) {
            do_action('get_designer_items_to_add', {vendor: vendor._id})
                .then(response => {
                    if (response.signal) {
                        let {itemAdd} = this.props
                        let {allItem, allCategory} = response.data
                        let dataCategory = {}
                        allCategory.map(cat => {
                            dataCategory[cat._id] = cat.name
                        })

                        allItem = allItem.filter(it => {
                            return itemAdd.indexOf(it._id) < 0
                        })
                        this.setState({
                            items: allItem,
                            dataCategory,
                            quantity: 1
                        })
                    } else console.log(response)
                })
                .catch(err => console.log(err))
        }
    }

    changeEntity = (e) => {
        this.setState({ quantity: e.target.value })
    }

    renderItem = () => {
        if (!this.state.items.length) return
        let result = this.state.items.map((item, index) =>
            <option value={item._id} key={index}>{item.title}</option>
        )
        return result
    }

    selectItem = (e) => {
        if (e.target.value) {
            let { items } = this.state
            items.map((item) => {
                if (item._id === e.target.value) {
                    this.setState({
                        selectItemId: e.target.value,
                        selectItem: item
                    });
                    return;
                }
            })
        }
    }

    addNewItem = (e) => {
        e.preventDefault()
        do_action('add_new_quote_designer_item', {
            item: this.state.selectItem,
            quantity: this.state.quantity,
            vendor: this.props.vendor,
            quote: this.props.quote
        })
            .then(data => {
                if (data.signal) {
                    let $ = window.$;
                    $('#modal-add-item-designer').modal('hide');
                    this.setState({
                        selectItemId: '',
                        quantity: 1,
                        selectItem: {}
                    })
                    this.props.addNewItem(data.data);
                } else {
                    alert('Something went wrong');
                }
            })
            .catch(err => console.log(err))
    }

    render() {
        let {selectItem, dataCategory} = this.state
        return (
            <div className="modal fade" id="modal-add-item-designer" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog" role="document">
                    <div className="modal-ruhu">
                        <div className="mdr-title">
                            <div className="text">Add Items</div>
                            <a href="#" data-dismiss="modal" className="closeX">
                                <img src="/images/icon-close.png" alt="" />
                            </a>
                        </div>
                        <div className="mdr-content">
                            <div className="form-group">
                                <select className="form-control form-control-mix" value={this.state.selectItemId} onChange={this.selectItem.bind(this)}>
                                    <option value="">Select an item</option>
                                    {this.renderItem()}
                                </select>
                            </div>
                            {(this.state.selectItemId) && <div>
                                <div className="form-group">
                                    <div className="clearfix vendor-item-update-modal">
                                        <div className="pull-left img">
                                            <img src={(selectItem.image_path) ? BASE_URL_ADMIN + '/uploads/' + selectItem.image_path : '/images/i4.png'} alt="" className="img-responsive" />
                                        </div>
                                        <div className="info">
                                            <div className="name">{this.state.selectItem.title}</div>
                                            <div className="text-primary-kt fontSemiBold">{`${selectItem.price}/${selectItem.type_price}`}</div>
                                            <div className="text-primary-kt">{`Group: ${selectItem.category_id ? (dataCategory[selectItem.category_id] || '') : ''}`}</div>
                                        </div>
                                    </div>
                                </div>
                                <p>Quantity</p>
                                <div className="form-group">
                                    <input type="number" className="form-control form-control-mix" value={this.state.quantity} onChange={this.changeEntity.bind(this)} />
                                </div>
                                <div className="form-group">
                                    <a href="#" className="bg-blue btn-block text-center btn-blue" onClick={this.addNewItem.bind(this)}>Add new item</a>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModalAddItemDesigner

